import Vue from "vue";

export default {
	state: {
		logs: [],
		logPagination: {}
	},
	mutations: {
		setLogsOnState(state, logs) {
			state.logs = logs;
		},
		setLogPaginationOnState(state, logPagination) {
			state.logPagination = logPagination;
		}
	},
	actions: {
		getLogs({ commit }, pagination) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("/Log", pagination)
					.then((response) => {
						this.state.loading = false;
						commit("setLogsOnState", response.data.data.list);
						commit("setLogPaginationOnState", response.data.data.pagination);
						resolve(response.data.data.list);
					})
					.catch((error) => {
						reject(error);
					});
			});
		}
	},
	getters: {
		logs({ logs }) {
			return logs;
		},
		logPagination({ logPagination }) {
			return logPagination;
		}
	}
};
